<div class="admin-modal admin-dashboard-edit" [class.is-loading]="loading">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         (click)="minimise = !minimise"
         title="{{ minimise ? 'Expand' : 'Minimise' }}"></i>
      <i class="fa fa-times" (click)="cancel()" title="Close"></i>
    </div>
  </div>

  <!-- Loader -->
  @if (loading) {
<div class="form-loader">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
  </div>
}

  <!-- Body -->
  <form #saveDashboardFrm="ngForm" novalidate
        class="modal-body" [hidden]="minimise || loading">
    <!-- ============================================================ Dashboard panel -->
    <div class="panel panel-default panel-dashboard">
      <div class="panel-heading"><span>Dashboard</span></div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-4">
            <label>Dashboard Name:</label>
            <input type="text" class="form-control"
                   name="dashboard_name" required
                   #dashNameCtrl="ngModel"
                   [(ngModel)]="dashboard.dashboard_name"
                   [class.error-field]="dashNameCtrl.invalid && (dashNameCtrl.touched || submitted)">
          </div>
          <div class="col-md-4">
            <label>Dashboard Desc:</label>
            <input type="text" class="form-control"
                   name="dashboard_desc"
                   [(ngModel)]="dashboard.dashboard_desc">
          </div>
          <div class="col-md-4">
            <label>Dashboard Alert Text:</label>
            <input type="text" class="form-control"
                   name="dashboard_alert_text"
                   [(ngModel)]="dashboard.dashboard_alert_text">
          </div>
        </div>
        <div class="row row-spaced">
          <div class="col-md-4">
            <label>Dashboard Type:</label>
            <input type="text" class="form-control"
                   name="dashboard_type" required
                   #dashTypeCtrl="ngModel"
                   [(ngModel)]="dashboard.dashboard_type"
                   [class.error-field]="dashTypeCtrl.invalid && (dashTypeCtrl.touched || submitted)">
          </div>
          @if (dashboard.dashboard_id) {

            <div class="col-md-4">
              <label>Dashboard Id:</label>
              <input type="text" class="form-control read-only-field"
                     [(ngModel)]="dashboard.dashboard_id"
                     name="dashboard_id" disabled>
            </div>
            <div class="col-md-4">
              <label>Dashboard Key:</label>
              <input type="text" class="form-control read-only-field"
                     [(ngModel)]="dashboard.dashboard_key"
                     name="dashboard_key" disabled>
            </div>
          
}
        </div>
      </div>
    </div>

    <!-- ============================================================ Sheet panel -->
    <div class="panel panel-default panel-sheets">
      <div class="panel-heading"><span>Sheet</span></div>
      <div class="panel-body">
        @for (sheet of dashboard.data_sheets; track trackRow(i, sheet); let i = $index) {

          <div class="row sheet-border">
            @if (sheet.sheet_key) {

              <div class="flex-box">
                <label>Key:</label>
                <input type="text" class="form-control read-only-field"
                       [(ngModel)]="sheet.sheet_key"
                       [name]="'key_' + i" disabled>
              </div>
            
}
            <div class="flex-box">
              <label>Name:</label>
              <input type="text" class="form-control" required
                     [(ngModel)]="sheet.name"
                     [name]="'name_' + i"
                     #sheetNameCtrl="ngModel"
                     (ngModelChange)="onSheetNameChange()"
                     [class.error-field]="sheetNameCtrl.invalid && (sheetNameCtrl.touched || submitted)">
            </div>
            <div class="flex-box">
              <label>Action Code:</label>
              <input type="text" class="form-control" required
                     [(ngModel)]="sheet.action_code"
                     [name]="'action_code_' + i"
                     #sheetActionCodeCtrl="ngModel"
                     [class.error-field]="sheetActionCodeCtrl.invalid && (sheetActionCodeCtrl.touched || submitted)">
            </div>
            <div class="flex-box">
              <label>Action Url:</label>
              <input type="text" class="form-control"
                     [(ngModel)]="sheet.action_id"
                     [name]="'action_id_' + i">
            </div>
            <div class="flex-box flex-box-action">
              <i class="fa fa-minus-circle del-icn"
                 title="Remove sheet"
                 (click)="removeSheetRow(i)"></i>
            </div>
          </div>
        
}
        <div class="add-row-action">
          <i class="fa fa-plus-circle fa-lg plus-icn"
             title="Add sheet"
             (click)="addSheetRow()"></i>
        </div>
      </div>
    </div>

    <!-- ============================================================ Filters panel -->
    <div class="panel panel-default panel-filters">
      <div class="panel-heading"><span>Filters</span></div>
      <div class="panel-body">
        @for (filter of dashboard.filters; track trackRow(i, filter); let i = $index) {

          <div class="row sheet-border">
            <div class="flex-box">
              <label>Name:</label>
              <input type="text" class="form-control" required
                     [(ngModel)]="filter.name"
                     [name]="'filtername_' + i"
                     #filterNameCtrl="ngModel"
                     [class.error-field]="filterNameCtrl.invalid && (filterNameCtrl.touched || submitted)">
            </div>
            <div class="flex-box">
              <label>Sheets to filter:</label>
              <ap-dropdown class="full-width-multiselect"
                             [list]="filter.sheetMultiSelectObj.dropdownValues"
                             [(ngModel)]="filter.sheetMultiSelectObj.selected"
                             [name]="'sheet_' + i"
                             [selectType]="'multiple'"
                             [enableNgContent]="false"
                             [optionName]="'name'"
                             [optionValue]="'value'"
                             [title]="'Select Sheets'"
                             [inputAriaLabel]="'Sheets to filter'"
                             [hideTitleOnInput]="true"
                             [showSearchbox]="false"
                             [showSelectAll]="false"
                             (onSelect)="onFilterSheetSelectionChange(filter, $event.selected)">
              </ap-dropdown>
            </div>
            <div class="flex-box">
              <label>
                Filter By:
                @if (filter.sheetMultiSelectObj.loadingPredicate) {
<span>
                  <i class="fa fa-spinner fa-spin"></i>
                </span>
}
              </label>
              <select class="form-control" required
                      [(ngModel)]="filter.predicate"
                      [name]="'predicate_' + i"
                      [disabled]="filter.sheetMultiSelectObj.disablePredicates ?? false"
                      #filterPredCtrl="ngModel"
                      [class.error-field]="filterPredCtrl.invalid && (filterPredCtrl.touched || submitted)">
                <option [ngValue]="''" disabled></option>
                @for (p of filter.sheetMultiSelectObj.predicates; track $index) {
<option [ngValue]="p">{{ p }}</option>
}
              </select>
            </div>
            <div class="flex-box flex-box-action">
              <i class="fa fa-minus-circle del-icn"
                 title="Remove filter"
                 (click)="removeFilterRow(i)"></i>
            </div>
          </div>
        
}
        <div class="add-row-action">
          <i class="fa fa-plus-circle fa-lg plus-icn"
             title="Add filter"
             (click)="addFilterRow()"></i>
        </div>
      </div>
    </div>

    <!-- ============================================================ Components List panel -->
    <div class="panel panel-default panel-components">
      <div class="panel-heading">
        <span>Components List</span>
        <button type="button" class="btn btn-sm btn-success pull-right"
                [disabled]="!dashboard.dashboard_id"
                (click)="addChartRow()">
          Create Row
        </button>
        @if (!dashboard.dashboard_id) {
<span class="components-hint">
          Save the dashboard first to add components
        </span>
}
      </div>
      <div class="panel-body">
        @if (!dashboard.components || dashboard.components.length === 0) {
<h3 class="text-center empty-msg">
          No components available. Save the dashboard, then click "Create Row" to start.
        </h3>
}

        @for (row of dashboard.components; track trackRow(rowIdx, row); let rowIdx = $index) {
<div
             class="comp-list clearfix"
             draggable="true"
             (dragstart)="onRowDragStart($event, rowIdx)"
             (dragenter)="onRowDragEnter(rowIdx)"
             (dragover)="onRowDragOver($event)"
             (dragend)="onRowDragEnd()">
          <div class="drag-row">
            @if ((dashboard.components?.length || 0) > 1) {
<div class="drag-handler"
                
                 title="Drag row">:::</div>
}

            <div class="drag-comp">
              @for (box of row; track $index; let boxIdx = $index) {
<div
                   class="each-char-box"
                   draggable="true"
                   (dragstart)="onBoxDragStart($event, rowIdx, boxIdx)"
                   (dragenter)="onBoxDragEnter(rowIdx, boxIdx)"
                   (dragover)="onRowDragOver($event)"
                   (dragend)="onBoxDragEnd()"
                   [hidden]="box.hide"
                   [ngClass]="{
                     'col-md-12': box.columns === 12 || box.columns === '12',
                     'col-md-6': box.columns === 6 || box.columns === '6',
                     'col-md-4': box.columns === 4 || box.columns === '4',
                     'col-md-3': box.columns === 3 || box.columns === '3',
                     'create-comp-chartBox': !box.title
                   }">
                @if (box.title) {

                  <div class="items">
                    <div class="img" aria-hidden="true">
                      <i class="fa fa-bar-chart"></i>
                    </div>
                  </div>
                  <div class="items wrapper">
                    <div><label>Title:</label> {{ box.title }}</div>
                    <div><label>Type:</label> {{ box.component_type }}</div>
                  </div>
                
}

                @if (!box.title) {
<div class="items">
                  <button type="button" class="btn btn-sm btn-create-component"
                          [disabled]="!dashboard.dashboard_id"
                          (click)="openChartEditor(rowIdx, boxIdx, true)">
                    Create Component
                  </button>
                </div>
}

                <div class="box-actions">
                  @if (box.title) {
<i class="fa fa-pencil-square-o"
                    
                     title="Edit component"
                     (click)="openChartEditor(rowIdx, boxIdx, false)"></i>
}
                  @if (!box.merged && !box.deleting) {
<i class="fa fa-trash-o"
                    
                     title="Delete component"
                     (click)="deleteBox(rowIdx, boxIdx)"></i>
}
                  @if (box.deleting) {
<span><i class="fa fa-circle-o-notch fa-spin"></i></span>
}
                </div>

                @if (row.length < 4 && isLastVisibleBox(row, boxIdx) && row[0]?.component_type !== 'combinationChart') {
<i class="fa fa-plus-square add-extra-box"
                  
                   title="Add component to row"
                   (click)="addBox(row)"></i>
}
              </div>
}
            </div>
          </div>
        </div>
}
      </div>
    </div>
  </form>

  <!-- Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button type="button" class="btn btn-info"
            (click)="save()"
            [disabled]="crudLoading">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Save
    </button>
    <button type="button" class="btn btn-warning" (click)="cancel()">Cancel</button>
  </div>
</div>
